import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import NotFound from "../404";
import UserForm from "./User-Form";
import "./usercreate.css";

const CreateUser = () => {
  const { user_id } = useParams();
  const [userDetail, setUserDetail] = useState();
  const { sendRequest } = useHttp();
  const user_roles = useSelector((state) => state.auth.roles);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: true }));
    if (user_id) {
      document.title = `${endPoints.title} | Edit User`;
      sendRequest(
        { url: endPoints.getUser + "/" + user_id, method: "GET" },
        (response) => {
          if (response.id) {
            setUserDetail(response);
          }
          dispatch(authActions.setLoaderStatus({ status: false }));
        }
      );
    } else {
      document.title = `${endPoints.title} | Create User`;
      dispatch(authActions.setLoaderStatus({ status: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  const access = useSelector((state) => state.auth.access) || '';
  const isAgency = ['6','61','62','9'].some(c => access.includes(c));

  if (user_roles.role_id === 1 && !isAgency) return <NotFound />;

  return (
    <section className="uc-page">
      <div className="container">
        {/* Header */}
        <div className="uc-header">
          <Link to="/users" className="uc-back-btn" title="Back to Users">
            <i className="bi bi-arrow-left"></i>
          </Link>
          <div className="uc-header-text">
            <h2>{user_id ? "Edit User" : "Create User"}</h2>
            <p>{user_id ? "Update user details and access permissions" : "Add a new user to the platform"}</p>
          </div>
        </div>

        {/* Form Card */}
        <div className="uc-card">
          <UserForm userDetail={userDetail} />
        </div>
      </div>
    </section>
  );
};

export default CreateUser;
